import { Theme } from '@mui/material';
import { ChatMessageGroup } from '@provision/chat-utils';
import React, { useContext } from 'react';
import { getConversationChannelTypeByParticipation } from 'src/graphql/entities/conversation/conversation.mappings';
import type { ConversationParticipant } from 'src/graphql/entities/conversation/conversation.types';
import type { Partner } from 'src/graphql/entities/partner/partner';
import { useChatCommonData } from 'src/pages/Conversations/Chat/registry/common-data-context';
import { ChatMessageContext } from './chat-message-context';
import { ChatMessagesGroup } from './chat-messages-group';

const chatGroupSx = (theme: Theme) => ({ marginTop: theme.spacing(1) });

export const ChatMessageRow = React.memo(
  ({ item }: { item: ChatMessageGroup<ConversationParticipant> }) => {
    const { onUpdateMessage, onEditMessage, metaData } = useContext(ChatMessageContext);

    const partner = useChatCommonData((s) =>
      item.sender?.partnerId
        ? (s.partners[item.sender.partnerId] as Partner | undefined)
        : undefined,
    );
    const senderPresence = useChatCommonData((s) =>
      s.userPresenceMap.get(item.sender?.id ?? ''),
    );
    const conversationParticipations = useChatCommonData((s) => s.conversationParticipations);
    const selectedParticipantsState = useChatCommonData((s) => s.selectedParticipantsState);
    const receiver = selectedParticipantsState.getToParticipant();
    const isChatReadOnly = useChatCommonData((s) => s.isChatReadOnly);
    const reactionsEnabled = useChatCommonData((s) => s.reactionsEnabled);

    const conversationChannel = getConversationChannelTypeByParticipation(
      conversationParticipations,
    );

    return (
      <ChatMessagesGroup
        group={item}
        partner={partner}
        senderPresence={senderPresence}
        sx={chatGroupSx}
        conversationChannel={conversationChannel}
        receiver={receiver}
        onUpdateMessage={onUpdateMessage}
        onEditMessage={onEditMessage}
        readonly={isChatReadOnly}
        reactionsEnabled={reactionsEnabled}
        metaData={metaData}
      />
    );
  },
);
ChatMessageRow.displayName = 'ChatMessageRow';
